import src from "IMAGE";
export default { src, width: 892, height: 862, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/webp;base64,UklGRmwAAABXRUJQVlA4TGAAAAAvB8ABAM1VICICHghADgIAAIAT8FQBqUGFABNMAAYAMEAAAoEBvwcAAAAAAAAAAAAAAAAACUACCc8CAEBEJH5VQi45mlXtEtyjl357muk+W2/eqQFt7HpoLcc4dAUkEjI="};
